import React from 'react';

const ButtonInformativoStepsIndicators = ({ classNameStepOne, classNameStepTwo, classNameStepThree, classNameStepFour }) => {
  return (
    <div className="row stepsMargin">
      <div className="col-4 col-sm-4 col-md-1" />
      <div className="col-4 col-sm-4 col-md-10">
        <div className='row'>
          <div className="col-3">
            <div id="stepOne">
              <div className={`${classNameStepOne} circleOrBox`}>{null}</div>
            </div>
          </div>

          <div className="col-3">
            <div id="stepTwo">
              <div className={`${classNameStepTwo} circleOrBox`}>{null}</div>
            </div>
          </div>

          <div className="col-3">
            <div id="stepThree">
              <div className={`${classNameStepThree} circleOrBox`}>{null}</div>
            </div>
          </div>

          <div className="col-3">
            <div id="stepFour">
              <div className={`${classNameStepFour} circleOrBox`}>{null}</div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default ButtonInformativoStepsIndicators;
